module.exports = __webpack_public_path__ + "img/ico-scrap.2fff67bd.svg";